import { NavigateFunction } from 'react-router-dom';

export const redirectUser = (location: any, navigate: NavigateFunction) => {
  const { from } = location.state || { from: { pathname: '/' } };
  navigate(from, { replace: true });
};
